import React from 'react';
import { Box, Typography, Stepper, Step, StepLabel, useMediaQuery, useTheme } from '@mui/material';

interface StepsProps {
  currentStep: number;
  steps: string[];
}

const RegisterSteps: React.FC<StepsProps> = ({ currentStep, steps }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  // Não renderiza no mobile para economizar espaço
  if (isMobile) {
    return null;
  }
  
  return (
    <Box sx={{ 
      maxWidth: '1200px',
      margin: '0 0 20px',
      padding: '20px',
      backgroundColor: 'white',
      borderRadius: 3,
      boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
      border: '1px solid #e2e8f0',
    }}>
      <Typography variant="h6" sx={{ 
        textAlign: 'center', 
        marginBottom: 3,
        color: '#0f172a',
        fontWeight: '600',
        fontSize: '0.95rem',
      }}>
        Progresso do Cadastro
      </Typography>
      
      <Stepper 
        activeStep={currentStep - 1} 
        alternativeLabel
        sx={{
          '& .MuiStepLabel-root .Mui-completed': {
            color: '#10b981',
          },
          '& .MuiStepLabel-root .Mui-active': {
            color: '#1976d2',
          },
          '& .MuiStepLabel-root .MuiStepLabel-label': {
            fontSize: '0.75rem',
            fontWeight: '500',
          },
          '& .MuiStepConnector-root .MuiStepConnector-line': {
            borderColor: '#e2e8f0',
            marginTop: '5px',
          },
          '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
            borderColor: '#10b981',
          },
          '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line': {
            borderColor: '#1976d2',
          },
          '& .MuiStepIcon-root': {
            fontSize: '0.85rem',
            width: '2rem',
            height: '2rem',
          },
          '& .MuiStepIcon-text': {
            fontSize: '0.68rem',
            fontWeight: 'bold',
          },
        }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              sx={{
                '& .MuiStepLabel-label': {
                  color: index < currentStep - 1 ? '#10b981' : 
                         index === currentStep - 1 ? '#1976d2' : '#64748b',
                  fontWeight: index === currentStep - 1 ? '600' : '500',
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      
      <Typography variant="body2" sx={{ 
        textAlign: 'center', 
        marginTop: 2,
        color: '#64748b'
      }}>
        Etapa {currentStep} de {steps.length}
      </Typography>
    </Box>
  );
};

export default RegisterSteps;
